import { useCallback } from 'react';
import { useReducedMotion } from 'framer-motion';

let confettiFn = null;

async function loadConfetti() {
  if (confettiFn) return confettiFn;
  try {
    const mod = await import('canvas-confetti');
    confettiFn = mod.default || mod;
  } catch {
    confettiFn = null;
  }
  return confettiFn;
}

const DEFAULT_COLORS = ['#0EA5E9', '#FFC800', '#10B981', '#CE82FF', '#FF4B4B'];

export function useConfetti() {
  const shouldReduce = useReducedMotion();

  const fire = useCallback(
    async ({
      duration: _duration = 3000,
      particleCount = 120,
      spread = 80,
      origin = { y: 0.6 },
      colors = DEFAULT_COLORS,
      mobile = false,
    } = {}) => {
      if (shouldReduce) return;

      const confetti = await loadConfetti();
      if (!confetti) return;

      const count = mobile ? Math.floor(particleCount * 0.5) : particleCount;

      try {
        confetti({
          particleCount: count,
          spread,
          origin,
          colors,
          disableForReducedMotion: true,
        });

        // Second burst after 750ms for extra celebration
        if (!mobile) {
          setTimeout(() => {
            try {
              confetti({
                particleCount: Math.floor(count * 0.5),
                spread: 60,
                origin: { y: 0.7, x: 0.3 },
                colors,
                disableForReducedMotion: true,
              });
            } catch { /* noop */ }
          }, 750);
        }
      } catch { /* noop */ }
    },
    [shouldReduce]
  );

  const fireSmall = useCallback(
    async (origin = { y: 0.6 }) => {
      if (shouldReduce) return;
      const confetti = await loadConfetti();
      if (!confetti) return;
      try {
        confetti({
          particleCount: 40,
          spread: 50,
          origin,
          colors: DEFAULT_COLORS,
          disableForReducedMotion: true,
        });
      } catch { /* noop */ }
    },
    [shouldReduce]
  );

  return { fire, fireSmall };
}
